import { render } from "./DataDeletionTitle.vue?vue&type=template&id=451059c5&scoped=true"
import script from "./DataDeletionTitle.vue?vue&type=script&lang=js"
export * from "./DataDeletionTitle.vue?vue&type=script&lang=js"

import "./DataDeletionTitle.vue?vue&type=style&index=0&id=451059c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451059c5"]])

export default __exports__